import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export function Section({
  children,
  className,
  id,
  fullWidth = false,
  animate = true,
}) {
  const content = (
    <div className={cn(!fullWidth && 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8')}>
      {children}
    </div>
  );

  if (!animate) {
    return (
      <section id={id} className={cn('py-16 md:py-24', className)}>
        {content}
      </section>
    );
  }

  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={cn('py-16 md:py-24', className)}
    >
      {content}
    </motion.section>
  );
}

export function SectionHeader({
  title,
  subtitle,
  description,
  align = 'center',
  className,
}) {
  const alignClasses = {
    center: 'text-center items-center',
    left: 'text-left items-start',
    right: 'text-right items-end',
  };

  return (
    <div className={cn('flex flex-col gap-4 mb-12', alignClasses[align], className)}>
      {subtitle && (
        <span className="text-sm font-medium text-primary uppercase tracking-wider">
          {subtitle}
        </span>
      )}
      {title && (
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
          {title}
        </h2>
      )}
      {description && (
        <p className={cn(
          'text-base md:text-lg text-muted-foreground max-w-2xl',
          align === 'center' && 'mx-auto'
        )}>
          {description}
        </p>
      )}
    </div>
  );
}
